module.exports = __webpack_public_path__ + "h5/img/404.ea35f40c.png";